<template>
  <div class="loginBg">
    
       
      <div class="logbox">
         <div class="rightbox">
           <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container">
              <h3 class="title">词状元智能自习室分布 用户登录</h3>
              <el-form-item prop="account">
                <el-input type="text" prefix-icon="el-icon-user" @keyup.native.enter="handleSubmit2" v-model="ruleForm2.account" auto-complete="off" placeholder="帐户"></el-input>
              </el-form-item>
              <el-form-item prop="checkPass" class="loginpwd">
                <el-input v-model="ruleForm2.checkPass" @keyup.native.enter="handleSubmit2" prefix-icon="el-icon-key" auto-complete="off" placeholder="密码" show-password></el-input>
              </el-form-item>
              <el-form-item  class="remaberme">
                <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
              </el-form-item>
              <el-form-item style="width:100%;" class="loginbtn">
                <el-button type="primary" class="loginbtnspan" @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button>
              </el-form-item>
            </el-form>
         </div>
      </div>
    
    <div class="banquan">Copyright © 2016-2023 安徽云朵教育科技有限公司 <a style="color: greenyellow;margin-left: 30px;" target="_blank" href="https://beian.miit.gov.cn/">皖ICP备19018834号</a></div>
  </div>
</template>

<script>
  import { requestLogin } from '../api/api';
  
  export default {
    data() {
      return {
        logining: false,
        ruleForm2: {
          account: '',
          checkPass: ''
        },
        rules2: {
          account: [
            { required: true, message: '请输入账号', trigger: 'blur' },
          ],
          checkPass: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ]
        },
        checked: true
      };
    },
    methods: {
      handleReset2() {
        this.$refs.ruleForm2.resetFields();
      },
      handleSubmit2(ev) {
        var _this = this;

        
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
         
            _this.logining = true;
            
            var loginParams = { loginname: this.ruleForm2.account, pwd: this.ruleForm2.checkPass };
            // sessionStorage.setItem('user', JSON.stringify(loginParams));
            // _this.$router.push({ path: '/index' });

            requestLogin(loginParams).then(res => {
              this.logining = false;
              //NProgress.done();
              let { msg, code, data } = res;
              if (code != 0) {
                this.$message({
                  message: msg,
                  type: 'error'
                });
              } else {
                sessionStorage.setItem('user', JSON.stringify(data));
                _this.$router.push({ path: '/home' });
                
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }

</script>


<style  scoped>

   .loginBg{
     background: #32394b;
    height: 100%;
    overflow: hidden;
   }

   .logbox{
         width: 400px;
    position: absolute;
    left: 50%;
    margin-left: -200px;
    color: #fff;
    margin-top: 30vh;
   }

   .logbox h3{
     font-size: 26px;
    font-weight: normal;
   }

   .remaberme{
     text-align: right;
   }

   .loginpwd{
     margin-bottom: 0px !important;
   }

   .logbox .el-button{
     background: #409EFF;
     width: 100%;
   }

   .logbox .el-button:hover{
     background: #409EFF;
   }

   .banquan{
     color: #ccc;
    bottom: 10px;
    position: absolute;
    text-align: center;
    width: 100%;
   }
  
</style>